import React from 'react';
import { CalendarDays, Users, Trophy, ArrowUpRight, Crown } from 'lucide-react';
import { Link } from 'react-router-dom';
import TournamentSparks from './TournamentSparks';
import { STATUS_LABELS, formatDate, getWinner, getPrizes, participantCount } from './tournamentPresentation';
import styles from './TournamentExperience.module.css';

export function Status({ status }) {
  return <span className={`${styles.status} ${styles[status] || ''}`}><span />{STATUS_LABELS[status] || 'Скоро'}</span>;
}

export function Meta({ tournament }) {
  return <div className={styles.meta}>
    <span><CalendarDays size={15} />{formatDate(tournament.startDate)}</span>
    <span><Users size={15} />Участников: {participantCount(tournament)}</span>
  </div>;
}

export function Champion({ name, compact = false }) {
  return <div className={compact ? styles.winnerCompact : styles.champion}>
    {!compact && <TournamentSparks />}
    <div className={styles.crown}><Crown size={compact ? 22 : 38} /></div>
    <div><span className={styles.eyebrow}>Победитель турнира</span><strong>{name}</strong></div>
    {!compact && <span className={styles.championNote}>Имя в истории InterWorld</span>}
  </div>;
}

export function TournamentCard({ tournament, featured = false }) {
  const winner = getWinner(tournament);
  const firstPrize = getPrizes(tournament).find((p) => p.place === 1)?.rewards[0];
  return <Link to={`/tournaments/${tournament.id}`} className={`${styles.card} ${featured ? styles.featured : ''}`}>
    {featured && <TournamentSparks />}
    <div className={styles.cardContent}>
      <div className={styles.cardTop}>
        <span className={styles.eyebrow}>{featured ? (tournament.status === 'finished' ? 'Последний турнир' : 'В центре внимания') : 'InterWorld / Арена'}</span>
        <Status status={tournament.status} />
      </div>
      <h2>{tournament.title}</h2>
      <Meta tournament={tournament} />
      {featured && tournament.description && <p className={styles.cardDescription}>{tournament.description}</p>}
      {winner && <Champion name={winner} compact />}
      <div className={styles.cardFooter}>
        {firstPrize ? <span className={styles.firstPrize}><Trophy size={17} />{firstPrize}</span> : <span className={styles.firstPrize}>Состав и турнирная сетка</span>}
        <span className={styles.cardLink}>{featured ? 'Открыть турнир' : 'Подробнее'}<ArrowUpRight size={18} /></span>
      </div>
    </div>
    {featured && <div className={styles.arenaArt} aria-hidden="true"><div className={styles.arenaRing} /><Trophy strokeWidth={1} /><span>INTERWORLD<br />TOURNAMENTS</span></div>}
  </Link>;
}
